module.exports = __webpack_public_path__ + "img/home-03.afe3be52.png";